import { Plugin } from "@nuxt/types";

import { installGa4Capture } from "@/plugins/Ga4Capture";
import { CaptureWindow } from "@/utils/Ga4Capture";

const ga4Capture: Plugin = ({ app, $config, store }) => {
  app.router?.onReady(() => {
    const isEnabled = () => $config.ga4CaptureStatus === "enabled" &&
      store.getters["FeatureFlag/featureFlagGa4CaptureLobby"] === true;
    const install = () => {
      try {
        installGa4Capture(window as CaptureWindow, $config.ga4CaptureMeasurementId, isEnabled, () => {
          const route = app.router?.currentRoute;
          const template = route?.matched[route.matched.length - 1]?.path || "/unmatched";
          const base = app.router?.options.base?.replace(/\/$/, "") || "";

          return `${window.location.origin}${base}${template.startsWith("/") ? template : `/${template}`}`;
        });
      } catch {
        console.warn("GA4 parallel capture initialization unavailable");
      }
    };

    if ($config.ga4CaptureStatus !== "enabled") { install(); return; }
    store.watch(isEnabled, (enabled) => { if (enabled) { install(); } }, { immediate: true });
  });
};

export default ga4Capture;
